import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import CountUp from "react-countup";
import classes from "./styles.module.scss";
import VisibilitySensor from "react-visibility-sensor";
import { Title, Description } from "@/ui";

export const StatCounterWidget = ({ className, title, description, items, bgColor, titleColor }) => {
  return (
    <div className={clsx(className, `bg-${bgColor}`, classes.StatCounterWidget)}>
      <VisibilitySensor partialVisibility>
        {({ isVisible }) => (
          <Container>
            <Title title={title} tag="h1" className={clsx("mb-5", `text-${titleColor}`)} data-sourceflow-prop="title" />
            <Row>
              {items.map((i, k) => (
                <Col key={k} xs={12} md={4}>
                  <dl className={clsx(`bg-${i.statBgColor}`, `text-${i.textColor}`)}>
                    <dd>
                      {i.prefix}
                      {isVisible && <CountUp end={i.value} redraw={true} />}
                      {i.suffix}
                    </dd>
                    <dt>{i.label}</dt>
                  </dl>
                </Col>
              ))}
            </Row>
            <Description description={description} className="mt-5 small" data-sourceflow-prop="description" />
          </Container>
        )}
      </VisibilitySensor>
    </div>
  );
};

export default StatCounterWidget;
